import { useAppSelector } from 'app/hooks';
import deliveryService from 'features/Delivery/deliveryService';
import { selectDeliveryDeliveryStatusMap } from 'features/Delivery/deliverySlice';
import { Delivery } from 'features/Delivery/models/delivery';
import { DeliveryDetail } from 'features/Delivery/models/deliveryDetail';
import { checkIsDeliveryFailedOrUnsent } from 'features/Delivery/utils';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Col, Modal, Row, Table } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_YYYY_MM_DD, STATUS_SUCCESS } from 'utils';

export interface DeliveryDetailModalProps {
  delivery: Delivery | null;
  onClose: () => void;
}

const DeliveryDetailModal = ({ delivery, onClose }: DeliveryDetailModalProps) => {
  const { t } = useTranslation();
  const [deliveryDetailList, setDeliveryDetailList] = useState<Array<DeliveryDetail>>([]);

  // selector
  const deliveryStatus = useAppSelector(selectDeliveryDeliveryStatusMap);
  useEffect(() => {
    (async () => {
      if (delivery) {
        const res = await deliveryService.getDeliveryDetail(delivery.id);
        if (res.status === STATUS_SUCCESS) {
          setDeliveryDetailList(res.data.delivery_detail_list);
        }
      }
    })();
  }, [delivery]);
  if (!delivery) {
    return null;
  }

  const handleClose = () => {
    onClose && onClose();
  };
  return (
    <Modal show backdrop="static" onHide={handleClose} centered size="lg">
      <Modal.Body>
        <Row className="mb-3">
          <Col sm={3}>
            <div className="p-2 h5" style={{ backgroundColor: '#E1D5E7' }}>
              <strong>{t('DeliveryFeature.Text.list_of_distribution_status')}</strong>
            </div>
          </Col>
          <Col></Col>
        </Row>
        <div className="sticky-table table-movement-history mb-5" style={{ maxHeight: '500px' }}>
          <Table hover>
            <thead>
              <tr>
                <th className="text-center">{t('DeliveryFeature.Table.distribution_no')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.store_code')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.store_name')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.sales_type')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.regular_pattern')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.distribution_date')}</th>
                <th className="text-center">{t('DeliveryFeature.Table.distribution_status')}</th>
              </tr>
            </thead>
            <tbody>
              {deliveryDetailList.map((deliveryDetail, index) => {
                const isDeliveryFailedOrUnsent = checkIsDeliveryFailedOrUnsent(deliveryDetail.delivery_status);

                return (
                  <tr key={index}>
                    <td className="text-center">{delivery.id}</td>
                    <td className="text-center">{deliveryDetail.restaurant.cd}</td>
                    <td className="text-center">{deliveryDetail.restaurant.name}</td>
                    <td className="text-center">{deliveryDetail?.restaurant?.sale_type?.name}</td>
                    <td className="text-center">{deliveryDetail?.restaurant?.counter_pattern?.name}</td>
                    <td className="text-center">
                      {deliveryDetail.delivery_date &&
                        moment(deliveryDetail.delivery_date).format(DATE_FORMAT_YYYY_MM_DD)}
                    </td>
                    <td className={isDeliveryFailedOrUnsent ? 'text-center cell-warning' : 'text-center'}>
                      {deliveryStatus[deliveryDetail.delivery_status] || '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <Row>
          <Col>
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                {t('DeliveryFeature.Component.close')}
              </button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default DeliveryDetailModal;
